export const defaultMeta = [
	{ title: 'Savery Recipes' },
	{
		name: 'description',
		content:
			'Savery makes it easy to save and share your favorite recipes. Using AI, you can write recipes in a single text box without entering individual ingredients or steps.',
		'og:image': '/img/savery-logo.svg',
		'og:title': 'Savery Recipes',
	},
]

export default function filterMeta(pageMeta) {
	let filteredMeta = []
	pageMeta.forEach(meta => {
		Object.keys(meta).forEach(key => {
			filteredMeta = defaultMeta.filter(el => {
				return el[key] === undefined
			})
		})
	})
	// console.log('defaultMeta :>> ', filteredMeta)
	return [...filteredMeta, ...pageMeta]
}
